import './styles.css';
import { Game } from './game/Game';

const canvas = document.querySelector<HTMLCanvasElement>('#game-canvas');
if (!canvas) throw new Error('Missing #game-canvas element.');

const game = await Game.create(canvas);
game.start();
document.querySelector('#loading')?.remove();

if (import.meta.hot) {
  import.meta.hot.dispose(() => game.dispose());
}

// Offline play after the first visit (production builds only).
// The game boots after `load` has usually fired, so register now if the page is already loaded.
if (import.meta.env.PROD && 'serviceWorker' in navigator) {
  const register = () => navigator.serviceWorker.register(`${import.meta.env.BASE_URL}sw.js`).catch(() => {});
  if (document.readyState === 'complete') register();
  else window.addEventListener('load', register);
}
